import React from 'react'
import { Box, Field, Flex, Select } from '@workwhile/ui'
import { useInvoiceConfigContextValue } from '../context/InvoiceConfigProvider'
import { CompanyPicker } from './CompanyPicker'
import { BREAKDOWN_LEVEL_OPTIONS } from '../schemas/invoiceConfigValues'

type BreakdownLevelOption = (typeof BREAKDOWN_LEVEL_OPTIONS)[number]

export const InvoiceConfigFilters = () => {
  const {
    state: { companyId, breakdownLevels },
    actions: { setCompanyId, setBreakdownLevels },
  } = useInvoiceConfigContextValue()

  return (
    <Flex
      gap={3}
      mb={3}
      flexDirection={['column', 'column', 'row']}
      alignItems={['stretch', 'stretch', 'flex-end']}
      maxWidth={['100%', '100%', '100%', '70%']}
    >
      <Box flex={1} minWidth={0}>
        <CompanyPicker value={companyId} onChange={setCompanyId} />
      </Box>
      <Box flex={1} minWidth={0}>
        <Field label="Breakdown Levels">
          <Select<BreakdownLevelOption, true>
            block
            isMulti
            isClearable
            placeholder="All breakdown levels"
            options={BREAKDOWN_LEVEL_OPTIONS}
            value={BREAKDOWN_LEVEL_OPTIONS.filter((option) =>
              breakdownLevels.includes(option.value)
            )}
            onChange={(selected) => {
              setBreakdownLevels(selected.map((option) => option.value))
            }}
            aria-label="Filter by breakdown levels"
          />
        </Field>
      </Box>
    </Flex>
  )
}
